(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/ticket-gifts/assets/javascripts/barcode/components/barcode-print.js') >= 0) return;  svs.modules.push('/modules/ticket-gifts/assets/javascripts/barcode/components/barcode-print.js');
"use strict";


const BarcodePrint = _ref => {
  let {
    giftCode,
    manual,
    numberOfTickets,
    totalPrice
  } = _ref;
  const Brand = svs.ui.ReactBrand;
  const ManualInfo = svs.ticket_gifts.barcode.components.ManualInfo;
  React.useEffect(() => {
    JsBarcode('#js-voucher-barcode', "VV".concat(giftCode), {
      format: 'code128',
      width: 2,
      displayValue: false
    });
  }, [giftCode]);
  let header = '';
  let subheader = '';
  let info = '';
  switch (true) {
    case Number(numberOfTickets) === 1:
      header = 'Kod för presentlott';
      subheader = "En presentlott till ett v\xE4rde av ".concat(totalPrice, " kr");
      info = 'Presentlott - Uppge koden för ditt spelombud eller visa den och streckkoden för inläsning.';
      break;
    case numberOfTickets > 1:
      header = 'Kod för presentlotter';
      subheader = "".concat(numberOfTickets, " presentlotter till ett v\xE4rde av ").concat(totalPrice, " kr");
      info = 'Presentlotter - Uppge koden för ditt spelombud eller visa den och streckkoden för inläsning.';
      break;
    case !numberOfTickets:
      header = 'Kod för present';
      subheader = '';
      info = 'Present - Uppge koden för ditt spelombud eller visa den och streckkoden för inläsning.';
      break;
    default:
  }
  return React.createElement("div", {
    className: "barcode-print-container"
  }, React.createElement("div", {
    className: "f-500 barcode-print-top-info"
  }, info), React.createElement("div", {
    className: "barcode-print-content"
  }, React.createElement("div", {
    className: "barcode-print-brand padding-top-2 padding-bottom-2"
  }, React.createElement(Brand, {
    brand: "svenskaspel-twolines",
    emblem: true
  })), React.createElement("div", {
    className: "f-900"
  }, header), React.createElement("div", {
    className: "f-700 f-bold"
  }, subheader), React.createElement("div", {
    className: "padding-2 margin-bottom-2 f-700 f-normal"
  }, "Scanna streckkoden under kundsk\xE4rmen i din spelbutik med mobilen."), React.createElement("div", {
    className: "margin-bottom-2 f-700 f-normal"
  }, "Du kan \xE4ven uppge koden f\xF6r kassapersonalen."), React.createElement("div", {
    className: "f-800"
  }, giftCode && giftCode.replace(/ /g, '').replace(/(.{3})/g, '$1 ').trim()), manual && React.createElement(ManualInfo, null), React.createElement("div", {
    className: manual ? 'padding-top-1' : 'padding-3'
  }, React.createElement("img", {
    id: "js-voucher-barcode"
  })), numberOfTickets > 1 && React.createElement("div", {
    className: "f-700 f-normal padding-2"
  }, "Koden \xE4r en v\xE4rdehandling tills dina lotter \xE4r uth\xE4mtade."), React.createElement("div", {
    className: "f-700 f-bold padding-2"
  }, "Beh\xF6ver du hj\xE4lp?"), React.createElement("div", {
    className: "f-700 f-normal padding-bottom-4"
  }, "Kontakta Kundservice. Telefon 0770-11 11 11.")));
};
setGlobal('svs.ticket_gifts.barcode.components.BarcodePrint', BarcodePrint);

 })(window);